import { makeVar } from '@apollo/client';

export const actionsInProgressAmount = makeVar(0);
